import type { IntlShape } from "react-intl";
import { Path, Shape } from "three";
import {
	type ThreeInputLinesType,
	ThreeShapeSideTypes,
	type ThreeSidePathsType,
} from "../../../../../types/three";
import type { DimensionProperties } from "../../../../../types/workpiece";
import type InputType from "../../../Input/InputType";
import { JsonInputType } from "../../../Input/JsonInputType";
import type { SideName } from "../../../Side/SideName";
import Rectangle from "../Rectangle";

export default class Square extends Rectangle {
	public static code = "plate_rectangle_square";

	public getDimensionsString(input: InputType, intl: IntlShape): string | undefined {
		if (input.width !== undefined) {
			const { width: length } = this.formatInputs(input, intl, "decimal");
			const { width } = this.formatInputs(input, intl);

			return `${length} x ${width}`;
		}
		return undefined;
	}
	public calculateSideLength(_side: SideName, input: InputType): number | undefined {
		const width = Number(input[JsonInputType.Width]);

		return width;
	}

	public calculateSheetDimensions(input: InputType): { length: number; width: number } | undefined {
		const side = Number(input[JsonInputType.Width]);

		if (!Number.isNaN(side)) {
			return { length: side, width: side };
		}
	}

	public getThreeShape(props: DimensionProperties["plate_rectangle_square"]) {
		const [width] = [props.width / 1000];

		return new Shape()
			.moveTo(0, 0)
			.lineTo(width, 0)
			.lineTo(width, width)
			.lineTo(0, width)
			.lineTo(0, 0);
	}

	public getThreeSidePaths(
		props: DimensionProperties["plate_rectangle_square"],
	): ThreeSidePathsType[] {
		const [length, width] = [props.width / 1000, props.width / 1000];

		return [
			{
				path: new Path().moveTo(0, 0).lineTo(length, 0),
				code: "length2",
				type: ThreeShapeSideTypes.side,
			},
			{
				path: new Path().moveTo(length, 0).lineTo(length, width),
				code: "width2",
				type: ThreeShapeSideTypes.side,
			},
			{
				path: new Path().moveTo(length, width).lineTo(0, width),
				code: "length1",
				type: ThreeShapeSideTypes.side,
			},
			{
				path: new Path().moveTo(0, width).lineTo(0, 0),
				code: "width1",
				type: ThreeShapeSideTypes.side,
			},
		];
	}

	public getThreeInputLines(
		props: DimensionProperties["plate_rectangle_square"],
	): ThreeInputLinesType[] {
		const [width] = [props.width / 1000];

		return [
			{
				dimension: props.width,
				path: new Path().moveTo(0, 0).lineTo(0, width),
				type: ThreeShapeSideTypes.side,
				code: "width",
			},
		];
	}

	public getDimensions(props: DimensionProperties["plate_rectangle_square"]) {
		return {
			width: props.width ? props.width : 1000,
		};
	}
}
